import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import TareasTerminadas from '../../../../general/TareasTerminadas';
import emma_w from './../../../../../global/imagenes/emma_w.png';
import { FormularioDesistimientoBienestar } from '../../forms/FormularioDisentimientoBienestar';
import { FormularioDesentimientoTrasladoEPSBienestar } from '../../forms/FormularioDisentimientoTrasladoEPSBienestar';
import FormatoFasesBienestar from '../../forms/FormatoFasesBienestar';
import FormatoSesiones from '../../forms/FormatoSesiones';
import {
    COD_ESTADO_CIERRE,
    COD_ESTADO_ATENDIDO,
    COD_CRISIS,
    COD_SOCIOEMOCIONAL,
} from '../../../helper';
import MensajeSinPermiso from './MensajeSinPermiso';
import { MENSAJE_SIN_PERMISO_PROFESIONAL } from '../../helpers/bienestarAccesoPermisos';

const ESTILO_AVISO_CIERRE_ESTUDIANTE = {
    width: '100%',
    margin: '0 auto 16px',
    padding: '12px 18px',
    borderRadius: 10,
    background: '#fafafa',
    boxShadow: '0px 2px 6px rgba(0,0,0,0.04)',
};

const ESTILO_AVISO_CIERRE_ADMIN = {
    width: '100%',
    margin: '0 auto 16px',
    padding: '12px 18px',
    borderRadius: 10,
    background: '#f5f7fb',
    boxShadow: '0px 2px 6px rgba(0,0,0,0.04)',
};

const ESTILO_TYPOGRAPHY = { marginBottom: 4, textAlign: 'justify', fontSize: '0.9rem' };
const ESTILO_TYPOGRAPHY_ROJO = { marginBottom: 0, color: '#ec4b4b', textAlign: 'justify', fontSize: '0.9rem' };
const ESTILO_TYPOGRAPHY_ADMIN = { marginBottom: 0, textAlign: 'justify', fontSize: '0.9rem' };
const ESTILO_LOADING = { minHeight: 420, display: 'flex', alignItems: 'center', justifyContent: 'center' };
const ESTILO_GRID_ITEM = { display: 'flex', justifyContent: 'center' };


function BienestarFormatosContenido({
    formatosReady,
    formatosCargando,
    codigoEstado,
    codigoServicioActual,
    esEquidadGenero,
    esVistaEstudiante,
    modoLectura,
    puedeVerContenido,
    disentimientoCompletado,
    disentimientoEpsCompletado,
    fasesFormatos,
    formulariosCompletadosPorFase,
    sesionesFormatos,
    formulariosCompletadosPorSesion,
    sesionSeleccionadaEnFormatos,
    tipoServicioActual,
    onAbrirDisentimiento,
    onAbrirDisentimientoEps,
    onVerDisentimiento,
    onVerDisentimientoEps,
    onVerDetalle,
    onModuleSelectSesion,
    onModuleSelectFase,
}) {
    if (!formatosReady) {
        return (
            <div style={ESTILO_LOADING}>
                <TareasTerminadas
                    mensaje="Cargando.."
                    marginTop="7%"
                    imagen={emma_w}
                    widthImg="7%"
                    cargando={true}
                />
            </div>
        );
    }

    if (!puedeVerContenido) {
        return <MensajeSinPermiso mensaje={MENSAJE_SIN_PERMISO_PROFESIONAL} />;
    }

    if (codigoEstado === COD_ESTADO_CIERRE) {
        const handleClickDisentimiento = () => {
            if (modoLectura && disentimientoCompletado) {
                if (typeof onVerDisentimiento === 'function') onVerDisentimiento();
            } else if (typeof onAbrirDisentimiento === 'function') {
                onAbrirDisentimiento();
            }
        };
        const handleClickDisentimientoEps = () => {
            if (modoLectura && disentimientoEpsCompletado) {
                if (typeof onVerDisentimientoEps === 'function') onVerDisentimientoEps();
            } else if (typeof onAbrirDisentimientoEps === 'function') {
                onAbrirDisentimientoEps();
            }
        };

        return (  
            <>
                {esVistaEstudiante ? (
                    <div style={ESTILO_AVISO_CIERRE_ESTUDIANTE}>
                        <Typography variant="body2" style={ESTILO_TYPOGRAPHY}>
                            El apartado de disentimiento debe diligenciarse únicamente cuando se haya tomado la decisión de no continuar con el proceso.
                        </Typography>
                        <Typography variant="body2" style={ESTILO_TYPOGRAPHY_ROJO}>
                            Por favor, no diligencie este apartado si desea continuar con el proceso.
                        </Typography>
                    </div>
                ) : (
                    <div style={ESTILO_AVISO_CIERRE_ADMIN}>
                        <Typography variant="body2" style={ESTILO_TYPOGRAPHY_ADMIN}>
                            En esta vista puedes consultar el detalle de cada disentimiento y descargar el archivo PDF diligenciado por el estudiante.
                        </Typography>
                    </div>
                )}
                <Grid container spacing={2} justify="center" alignItems="flex-start">
                    <Grid item xs={12} md={6} style={ESTILO_GRID_ITEM}>
                        <FormularioDesistimientoBienestar
                            onSeleccionar={handleClickDisentimiento}
                            completada={disentimientoCompletado}
                            disabled={false}
                            modoLectura={modoLectura}
                            modoAdministrador={modoLectura}
                            mostrarMensajeDeshabilitado={!esVistaEstudiante}
                            mensajeDeshabilitado="Este disentimiento aún no ha sido diligenciado por el estudiante."
                        />
                    </Grid>
                    {(codigoServicioActual === COD_CRISIS || codigoServicioActual === COD_SOCIOEMOCIONAL) && (
                        <Grid item xs={12} md={6} style={ESTILO_GRID_ITEM}>
                            <FormularioDesentimientoTrasladoEPSBienestar
                                onSeleccionar={handleClickDisentimientoEps}
                                completada={disentimientoEpsCompletado}
                                disabled={false}
                                modoLectura={modoLectura}
                                modoAdministrador={modoLectura}
                                mostrarMensajeDeshabilitado={!esVistaEstudiante}
                                mensajeDeshabilitado="Este disentimiento aún no ha sido diligenciado por el estudiante."
                            />
                        </Grid>
                    )}
                </Grid>
            </>
        );
    }

    if (esEquidadGenero) {
        return (
            <FormatoFasesBienestar
                fases={fasesFormatos}
                loading={formatosCargando}
                formulariosCompletados={formulariosCompletadosPorFase}
                modoLectura={false}
                sesionInicial={sesionSeleccionadaEnFormatos}
                onVerDetalle={null}
                onModuleSelect={onModuleSelectFase}
                tipoServicio={tipoServicioActual}
            />
        );
    }

    const sesionesBloqueoSecuencial = codigoEstado === COD_ESTADO_ATENDIDO;
    return (
        <FormatoSesiones
            sesiones={sesionesFormatos}
            loading={formatosCargando}
            formulariosCompletados={formulariosCompletadosPorSesion}
            modoLectura={modoLectura}
            sesionInicial={sesionSeleccionadaEnFormatos}
            onVerDetalle={modoLectura ? onVerDetalle : null}
            onModuleSelect={onModuleSelectSesion}
            tipoServicio={tipoServicioActual}
            sesionesBloqueoSecuencial={sesionesBloqueoSecuencial}
        />
    );
}

export default React.memo(BienestarFormatosContenido);
